<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
import navMenuItems from '@/navigation/horizontal'
import { getUserData } from '@/auth/utils'
import { computed } from '@vue/composition-api'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    const filteredNavMenuItems = computed(() => {
      const userData = getUserData()
      if (userData && userData.email === 'kaan@hayalakademisi.com') {
        return [
          {
            title: 'Explicit Consent Forms',
            route: 'forms-explicit-consents',
            icon: 'CopyIcon',
          },
        ]
      }
      return navMenuItems
    })

    return {
      navMenuItems: filteredNavMenuItems,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
